import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { AiActionBanner } from '../AiActionBanner'
import { GuidedIntakePromoBannerCtaStyled } from './styles/GuidedIntakePromoBannerStyled'

interface IGuidedIntakePromoBannerProps {
  contactSalesUrl: string
  analyticsId: string
}

export const GuidedIntakePromoBanner = ({
  contactSalesUrl,
  analyticsId,
}: IGuidedIntakePromoBannerProps) => {
  const intl = useProcurifyIntl()

  const handleLearnMoreClick = () => {
    window.open(contactSalesUrl, '_blank', 'noopener,noreferrer')
  }

  return (
    <AiActionBanner
      analyticsId={analyticsId}
      action={
        <GuidedIntakePromoBannerCtaStyled
          analyticsId={`${analyticsId}-cta`}
          onClick={handleLearnMoreClick}
        >
          {intl.formatMessage(messages.learnMore)}
        </GuidedIntakePromoBannerCtaStyled>
      }
    >
      {intl.formatMessage(messages.bannerText)}
    </AiActionBanner>
  )
}
